(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["intro_top"] && !Shopify.designMode) return;
  try {
    
function initJKMenu() {
  const header = document.getElementById('jk-header');
  if(!header) return;

  const handleScroll = () => {
    if(!header.classList.contains('jk-force-solid')) {
      header.classList.toggle('jk-is-scrolled', window.scrollY > 10);
    }
  };
  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll(); 

  const detectContrast = () => {
    const main = document.querySelector('main');
    if (!main) return;
    
    const mediaEl = main.querySelector('img, video');
    let bgUrl = '';

    if (mediaEl && mediaEl.tagName.toLowerCase() === 'img') {
        bgUrl = mediaEl.currentSrc || mediaEl.src;
    } else if (mediaEl && mediaEl.tagName.toLowerCase() === 'video') {
        bgUrl = mediaEl.poster; 
    } else {
        const firstChild = main.firstElementChild;
        if (firstChild) {
            const style = window.getComputedStyle(firstChild);
            if (style.backgroundImage && style.backgroundImage !== 'none') {
                bgUrl = style.backgroundImage.slice(4, -1).replace(/["']/g, "");
            }
        }
    }

    if (!bgUrl) {
        header.classList.add('jk-text-dark'); 
        return;
    }

    const img = new Image();
    img.crossOrigin = "Anonymous"; 
    
    img.onload = function() {
        const canvas = document.createElement('canvas');
        canvas.width = img.width || 100;
        canvas.height = img.height || 100;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        
        try {
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            let r, g, b, avg;
            let colorSum = 0;
            let count = 0;
            
            for (let x = 0; x < data.length; x += 4 * 10) {
                r = data[x];
                g = data[x+1];
                b = data[x+2];
                avg = Math.floor((r * 299 + g * 587 + b * 114) / 1000);
                colorSum += avg;
                count++;
            }
            
            const brightness = Math.floor(colorSum / count);
            
            if (brightness > 127) {
                header.classList.add('jk-text-dark');
            } else {
                header.classList.add('jk-text-light');
            }
        } catch(e) {
            header.classList.add('jk-text-dark');
        }
    };
    
    img.onerror = () => header.classList.add('jk-text-dark');
    img.src = bgUrl + (bgUrl.includes('?') ? '&' : '?') + 'cb=' + new Date().getTime();
  };

  if (!header.classList.contains('jk-force-solid')) {
     setTimeout(detectContrast, 50); 
  }
}

document.addEventListener('DOMContentLoaded', initJKMenu);
document.addEventListener('shopify:section:load', (e) => {
  if (e.detail.sectionId === 'jk-menu' || e.target.querySelector('#jk-header')) {
    initJKMenu();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
